import Admin__OrganizationsController from './organizations.js';

import Admin__OrganizationApplicationsController from './applications.js';

import Admin__NamecardsController from './namecards.js';

import Admin__AdministratorsController from './administrators.js';

Skylark.App.Controllers.register({Admin__OrganizationsController, Admin__OrganizationApplicationsController, Admin__NamecardsController, Admin__AdministratorsController});
